<div class="stat-title" *ngIf="statDefinition.title">
  {{ statDefinition.title }}
</div>
<div class="stat-value" *ngIf="statValue || statValue === 0">
  {{ statValue | number }}
</div>

<div class="stat-delta" *ngIf="hasDelta" [class.up]="isDeltaUp" [class.down]="!isDeltaUp">
  <span class="delta-arrow">{{ isDeltaUp ? '▲' : '▼' }}</span>
  <span>{{ (statDefinition.deltaPercentage || 0) | number: '1.0-1' }}%</span>
  <span class="delta-label">{{ statDefinition.deltaLabel || 'vs last week' }}</span>
</div>
